import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/home/Home'
import ScanToSearch from '@/views/home/ScanToSearch'
import Cart from '@/views/cart/Cart'
import Payment from '@/views/check-out/Payment'
import CheckoutByCash from '@/views/check-out/CheckoutByCash'
import CheckoutByCard from '@/views/check-out/CheckoutByCard'
import VueQrcodeReader from 'vue-qrcode-reader'
import UserInfo from '@/views/user-info/UserInfo'
import ReportZ from '@/views/report/ReportZ'

Vue.use(VueQrcodeReader)
Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/scan-to-search',
      name: 'ScanToSearch',
      component: ScanToSearch
    },
    {
      path: '/cart',
      name: 'Cart',
      component: Cart
    },
    {
      path: '/payment',
      name: 'Payment',
      component: Payment
    },
    {
      path: '/checkout-by-cash',
      name: 'CheckoutByCash',
      component: CheckoutByCash
    },
    {
      path: '/checkout-by-card',
      name: 'CheckoutByCard',
      component: CheckoutByCard
    },
    {
      path: '/user-info',
      name: 'UserInfo',
      component: UserInfo
    },
    {
      path: '/report-z',
      name: 'ReportZ',
      component: ReportZ
    }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js